import { render, staticRenderFns } from "./syncPos.vue?vue&type=template&id=003d34ad&scoped=true&"
import script from "./syncPos.vue?vue&type=script&lang=js&"
export * from "./syncPos.vue?vue&type=script&lang=js&"
import style0 from "./syncPos.vue?vue&type=style&index=0&id=003d34ad&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "003d34ad",
  null
  
)

export default component.exports